export default __webpack_public_path__ + "static/media/ford_ranger_wildtrak.3cb37d32.png";